<onsip-header-main>
  <onsip-header-page-title>Recording library</onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="isDataObtained$">
  <onsip-header-main>
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="search"
          [placeholder]="'ONSIP_I18N.SEARCH' | translate"
          autocomplete="off"
        />
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        color="primary"
        class="att_menu-add"
        type="button"
        [routerLink]="views.ADMIN_RECORDING_SETUP"
      >
        {{ "ONSIP_I18N.ADD_RECORDING" | translate }}
      </button>
    </onsip-header-action-bar>
  </onsip-header-main>
  <onsip-rec-manager-link></onsip-rec-manager-link>
  <onsip-table-two
    class="recording-library-table"
    matSort
    multiTemplateDataRows
    [dataSource]="dataSource"
    [trackBy]="trackByRecordingId"
    [useGrid]="true"
    [hoverable]="true"
  >
    <!-- Name -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let recording">
        <span class="recording-name">
          {{ recording.name }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Location -->
    <ng-container matColumnDef="location">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
      <mat-cell *matCellDef="let recording">
        <span class="recording-location">
          {{ recording.location.join(", ") }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Duration -->
    <ng-container matColumnDef="duration">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Duration</mat-header-cell>
      <mat-cell *matCellDef="let recording">
        <span class="recording-duration">
          {{ recording.duration }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Recording Url -->
    <ng-container matColumnDef="recordingUrl">
      <mat-header-cell *matHeaderCellDef>Recording</mat-header-cell>
      <mat-cell *matCellDef="let recording">
        <span class="recording-audio-container">
          <audio
            preload="metadata"
            class="recording-audio-player"
            controls
            controlsList="nodownload"
            [src]="recording.recordingUrl | safeSrc"
          ></audio>
          <a
            id="admin-recording-greeting-download"
            (click)="$event.stopPropagation()"
            [href]="recording.recordingUrl | safeSrc"
            download
            type="audio/wav"
          >
            <mat-icon aria-label="download_greetings">get_app</mat-icon>
          </a>
        </span>
      </mat-cell>
    </ng-container>
    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef
        ><span class="empty-action-header-block"></span
      ></mat-header-cell>
      <mat-cell *matCellDef="let recording">
        @if (selectedRows.includes(recording.recordingId)) {
        <mat-icon color="primary" class="expansion-arrow">expand_less</mat-icon>
        } @if (!selectedRows.includes(recording.recordingId)) {
        <mat-icon color="primary" class="expansion-arrow">expand_more</mat-icon>
        }
        <div (click)="$event.stopPropagation()">
          <button mat-icon-button (click)="removeItem(recording, $event)" color="primary">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <!-- Expanded -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let recording"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(recording.recordingId)"
      >
        <onsip-recording-shelf [recording]="recording"></onsip-recording-shelf>
      </onsip-table-shelf-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="
        selectedRows.includes(row.recordingId)
          ? selectedRows.splice(selectedRows.indexOf(row.recordingId), 1)
          : selectedRows.push(row.recordingId)
      "
    ></mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (!dataSource.data.length || !search.value) {
      <span
        translate
        [translateParams]="{ value: 'ONSIP_I18N.RECORDINGS' | translate | lowercase }"
      >
        ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
      </span>
      } @if (search.value && dataSource.data.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    onsip-paginator-primary-icon
    showFirstLastButtons
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  <span class="mat-body-2"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
</onsip-loading-container>
